<template>
  <div class="rptLastTable">
    <lida-table
      :propscolumns="columns(query.gameid)"
      @rowClick="getCq9Detail"
      :data="items"
      :propsPageSize="50"
      align="right"
      :class="{ 'cq9-row': Number(query.gameid) > 100 }"
    ></lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GameDetailedReport from '@/views/ledger/mixins/game-detailed-report'
import totalData from 'utils/table-total-data'
export default {
  name: 'report-last',
  mixins: [GameDetailedReport],
  data () {
    return {
      items: [],
    }
  },
  computed: {
    query () {
      return this.$route.query
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      try {
        const { gameid, iscal, stdate, endate, buid, odddtl, mark, troddid, username } = this.query
        const data = {
          gameid,
          stdate,
          endate,
          buid: Number(buid),
          odddtl: Number(odddtl),
          troddid: troddid,
          mark,
          gamecode: this.judgeExgame(gameid) ? mark : '',
          stid: Number(this.query.stidlist),
          iscal: Number(iscal),
          repnum: this.judgeExgame(gameid) ? 14 : 4,
          username
        }
        if (this.judgeExgame(Number(gameid))) { // cq9的api要加"_cq9"，并筛选参数
          delete data.buid
          delete data.odddtl
          delete data.troddid
        } else {
          delete data.mark
        }
        const res = await this.$axios.assortLedger.assortLedgerReport(data)
        if ('status' in res && res.status === 0) return
        if (Number(this.query.gameid) == 101) {
          res['101'].forEach(it => {
            it["bonuswin"] = it["bonus"]
          });
        }
        const keys = Object.keys(res)
        this.items = res[keys]
        this.totalArr[gameid] = totalData(this.items, { yokekka: '', lpds: '' })
      } catch (error) {
        console.error(error);
        this.$Message.error("请勿改动网站资讯!");
        this.$router.push({ name: this.$route.matched[1].name })
      }
    },
    async getCq9Detail (data) { // CQ9注单明细
      try {
        if ([128, 130].some(it => it === Number(this.query.gameid))) return
        if (!this.judgeExgame(Number(this.query.gameid)) || data.betcalid == '') return
        const raw = { 
          round: data.betcalid,
          date: data.date.split(' ')[0],
          mid: data.mid,
          gamecode: data.deoddsrepname,
          stid: Number(this.query.stidlist),
          gameid: this.query.gameid
        }
        const res = await this.$axios.generalLedger.linkorderdetail_cq9(raw)
        if (res.length == 0) return
        window.open(res[0].data.data, "_blank")
      } catch (error) {
        console.error(error)
      }
    },
    judgeExgame(gameid) { // 判斷外站遊戲
      return gameid >= 101 && gameid <= 200
    }
  }
}
</script>

<style lang="scss">
.rptLastTable {
  .cq9-row tr:not(:last-of-type) {
    cursor: pointer;
  }
}
</style>